// extracted by mini-css-extract-plugin
export default {"button":"Button_button__t89sB","roundedButton":"Button_roundedButton__kNOb2","moreButton":"Button_moreButton__WgM07"};